import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export function useAuthenticateUser() {
  const auth = useContext(AuthContext);

  const unauthenticatedUser = {
    isUserLoggedIn: false,
    accessToken: null,
    activeCharityPermission: null,
    auth: null,
  };

  if (!auth) {
    return unauthenticatedUser;
  }

  const accessToken = auth.getAccessToken();
  const isUserLoggedIn = auth.isUserLoggedIn();
  const activeCharityPermission = auth.getActivePermission('charity');

  const userGuid = accessToken?.guid;

  if (!userGuid) {
    return unauthenticatedUser;
  }

  return {
    isUserLoggedIn,
    accessToken,
    activeCharityPermission,
    auth,
  };
}
